import React from 'react';
import Link from "next/link";

function LinkList({items, ulClassName, LiClassName}) {
    return (
        <ul className={(typeof ulClassName !== "undefined" ? ulClassName : '')}>
            {
                items.map((item, key) =>
                    <li className={(typeof LiClassName !== "undefined" ? LiClassName : '')} key={key}>
                        {
                            (!item.crossOverLink) ?
                                <Link href={item.href} as={item.hrefAs}>
                                    <a> {item.name}</a>
                                </Link>
                                :
                                <a href={item.hrefAs} id={item.id ?? ''}>{item.name}</a>
                        }
                    </li>
                )
            }
        </ul>
    )
}


export default React.memo(LinkList);